module.exports = __webpack_public_path__ + "img/notify-emoji-bell.ac0a3220.gif";